export default __webpack_public_path__ + "static/media/1-10@2x.e8e409c2.png";